import axios from "axios";
import { baseURL } from "../../../utils/http/http-common";

export const getTranslatedTextApiCall = async (id) => {
    const authToken = localStorage.getItem("token");

    try {
    const response = await axios.get(
      `${baseURL}/ApplicationTranslatedText/GetApplicationTextByLanguage/${id}`,{
        headers:{
            Authorization:`Bearer ${authToken}`
        }
      }
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};